import { Col, Container, Row } from "reactstrap";
import { CartEmpty, ExploreShortListItems } from "../../../../constants";

// This component displays a message when the cart is empty.
const EmptyState = () => {

  return (
    <section className="p-5">
      <Container fluid>
        <Row>
          <Col sm="12">
            <div>
              <Col sm="12" className="text-center">
                <h3>
                  <strong>{CartEmpty}</strong>
                </h3>
                <h5>{ExploreShortListItems}</h5>
              </Col>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default EmptyState;